<template>
  <div class="action-buttons mb-5 mt-5">
    <b-button
      variant="primary"
      size="sm"
      class="save-button font-weight-bolder mr-4"
      @click="$emit('save')"
      v-if="showSaveButton"
    >
      Lưu
    </b-button>
    <b-button
      variant="secondary"
      size="sm"
      class="cancel-button font-weight-bolder"
      @click="$emit('cancel')"
    >
      Hủy
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'ActionButtons',
  props: {
    /**
     * Whether to show the save button
     */
    showSaveButton: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.action-buttons {
  .save-button, .cancel-button {
    font-weight: 600 !important;
    width: 70px;
  }
}
</style>
